import React, { Component } from 'react';
import Input from '../../../forms/Input';

class SigningUsers extends Component {
    componentDidMount() {
        this._fetchUsers();
    }
    componentDidUpdate() {
        this._fetchUsers();
    }
    _fetchUsers() {
        if (this.props.shouldFetch) {
            const { organizationId, artistId, eventId, contractType } = this.props;
            this.props.fetch(organizationId, artistId, eventId, contractType);
        }
    }
    render() {
        return (
            <div className="ckp-inputs double-width">
                <Input
                    value={this.props.signers}
                    label={'Contract will be sent to'}
                    disabled={true}
                    className={'is-full-width'}
                />
            </div>
        );
    }
}

export default SigningUsers;
